document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initGaleriaProducto();
  initVariantesProducto();
  initVistaPrevia();
});

function initVistaPrevia() {
  var secciones = document.querySelectorAll('[data-bi-producto]');
  secciones.forEach(function (seccion) {
    var abrir = seccion.querySelector('[data-bi-preview-abrir]');
    var modal = seccion.querySelector('[data-bi-preview]');
    if (!abrir || !modal) return;

    var slides = modal.querySelectorAll('[data-bi-preview-slide]');
    var puntos = modal.querySelectorAll('[data-bi-preview-punto]');
    var prev = modal.querySelector('[data-bi-preview-prev]');
    var next = modal.querySelector('[data-bi-preview-next]');
    var cerrarBtns = modal.querySelectorAll('[data-bi-preview-cerrar]');
    var visor = modal.querySelector('[data-bi-preview-visor]');
    var indice = 0;
    var ultimoFoco = null;

    function mostrar(i) {
      if (!slides.length) return;
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      indice = i;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === indice); });
      puntos.forEach(function (p, idx) { p.classList.toggle('is-active', idx === indice); });
    }

    function alTecla(e) {
      if (e.key === 'Escape') cerrarModal();
      if (e.key === 'ArrowRight') mostrar(indice + 1);
      if (e.key === 'ArrowLeft') mostrar(indice - 1);
    }

    function abrirModal() {
      ultimoFoco = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('bi-preview-abierta');
      mostrar(0);
      var cerrar = modal.querySelector('[data-bi-preview-cerrar]');
      if (cerrar) cerrar.focus();
      document.addEventListener('keydown', alTecla);
    }

    function cerrarModal() {
      modal.hidden = true;
      document.body.classList.remove('bi-preview-abierta');
      document.removeEventListener('keydown', alTecla);
      if (ultimoFoco && typeof ultimoFoco.focus === 'function') ultimoFoco.focus();
    }

    abrir.addEventListener('click', abrirModal);
    cerrarBtns.forEach(function (b) { b.addEventListener('click', cerrarModal); });
    if (prev) prev.addEventListener('click', function () { mostrar(indice - 1); });
    if (next) next.addEventListener('click', function () { mostrar(indice + 1); });
    puntos.forEach(function (p) {
      p.addEventListener('click', function () { mostrar(parseInt(p.getAttribute('data-index'), 10)); });
    });

    if (visor) {
      var touchX = null;
      visor.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      visor.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var delta = e.changedTouches[0].clientX - touchX;
        if (Math.abs(delta) > 40) mostrar(delta < 0 ? indice + 1 : indice - 1);
        touchX = null;
      }, { passive: true });
    }

    // Protección básica: evita clic derecho, arrastre y guardado directo de la muestra.
    modal.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    modal.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  });
}

function initGaleriaProducto() {
  var secciones = document.querySelectorAll('[data-bi-producto]');
  secciones.forEach(function (seccion) {
    var principal = seccion.querySelector('[data-bi-galeria-principal]');
    var miniaturas = seccion.querySelectorAll('[data-bi-thumb]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt');
        if (full) principal.setAttribute('src', full);
        if (alt !== null) principal.setAttribute('alt', alt);
        miniaturas.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

function initVariantesProducto() {
  var secciones = document.querySelectorAll('[data-bi-producto]');
  secciones.forEach(function (seccion) {
    var wrap = seccion.querySelector('[data-bi-opciones]');
    var variantesScript = seccion.querySelector('[data-bi-variantes]');
    var variantInput = seccion.querySelector('[data-bi-variant-id]');
    var boton = seccion.querySelector('[data-bi-boton]');
    var botonTexto = seccion.querySelector('[data-bi-boton-texto]');
    var precio = seccion.querySelector('[data-bi-precio]');
    if (!wrap || !variantesScript || !variantInput) return;

    var variantes;
    try {
      variantes = JSON.parse(variantesScript.textContent);
    } catch (e) {
      return;
    }

    var grupos = wrap.querySelectorAll('[data-option-index]');

    function seleccionActual() {
      var seleccion = [];
      grupos.forEach(function (grupo) {
        var activo = grupo.querySelector('.is-active');
        seleccion.push(activo ? activo.getAttribute('data-value') : null);
      });
      return seleccion;
    }

    function actualizar() {
      var seleccion = seleccionActual();
      var variante = variantes.find(function (v) {
        var opciones = [v.option1, v.option2, v.option3];
        return seleccion.every(function (val, i) { return val === null || opciones[i] === val; });
      });
      if (!variante) return;

      variantInput.value = variante.id;

      if (precio) {
        var formateado = (variante.price / 100).toLocaleString('es-ES', { minimumFractionDigits: 2 });
        precio.textContent = formateado + '€';
      }

      if (boton) {
        boton.disabled = !variante.available;
      }
      if (botonTexto) {
        botonTexto.textContent = variante.available
          ? botonTexto.getAttribute('data-label-disponible') || botonTexto.textContent
          : botonTexto.getAttribute('data-label-agotado') || botonTexto.textContent;
      }
    }

    grupos.forEach(function (grupo) {
      var botones = grupo.querySelectorAll('[data-value]');
      botones.forEach(function (btn) {
        btn.addEventListener('click', function () {
          botones.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          actualizar();
        });
      });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.bi-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('bi-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bi-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: '200px 0px 200px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });

  // Red de seguridad: un salto de scroll muy grande (tecla Fin, arrastrar la
  // barra de scroll) puede mover un elemento de "por debajo" a "por encima"
  // del viewport sin que el observer llegue a detectarlo. Al terminar de
  // hacer scroll, revelamos sin animación todo lo que ya haya quedado por
  // encima o dentro del viewport aunque el observer no lo haya detectado.
  var revisar = function () {
    document.querySelectorAll('.bi-reveal:not(.bi-visible)').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        el.classList.add('bi-visible');
        observer.unobserve(el);
      }
    });
  };
  var ticking = false;
  var settleTimer = null;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(function () { revisar(); ticking = false; });
    }
    clearTimeout(settleTimer);
    settleTimer = setTimeout(revisar, 150);
  }, { passive: true });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-bi-countup]');
  if (!els.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var raw = el.getAttribute('data-bi-countup');
        var target = parseFloat(raw);
        var suffix = raw.replace(/^-?[\d.]+/, '');
        observer.unobserve(el);

        if (reduceMotion || isNaN(target)) {
          el.textContent = raw;
          return;
        }

        var duration = 1400;
        var start = null;
        function step(timestamp) {
          if (!start) start = timestamp;
          var progress = Math.min((timestamp - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * target) + suffix;
          if (progress < 1) window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );

  els.forEach(function (el) { observer.observe(el); });
}
